import * as z from "zod";

export const setSandboxPassword = {
  name: "setSandboxPassword" as const,
  input: z.object({ password: z.string().min(12) }),
  output: z.object({ success: z.boolean() }),
};
